import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const columnTextGridFn = /* @__PURE__ */ createRecipe('column-text-grid', {}, [])

const columnTextGridVariantMap = {}

const columnTextGridVariantKeys = Object.keys(columnTextGridVariantMap)

export const columnTextGrid = /* @__PURE__ */ Object.assign(memo(columnTextGridFn.recipeFn), {
  __recipe__: true,
  __name__: 'columnTextGrid',
  __getCompoundVariantCss__: columnTextGridFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: columnTextGridVariantKeys,
  variantMap: columnTextGridVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, columnTextGridVariantKeys)
  },
  getVariantProps: columnTextGridFn.getVariantProps,
})